import { createContext } from "react"
import { Credentials, UserRole } from "./auth.types"

export interface AuthContextType {
  login: (creds: Credentials) => Promise<void>
  VRlogin: (params: string) => Promise<void>
  logout: () => Promise<void>
  isAuth: () => boolean
  role: UserRole | null
  loading: boolean
  username: string | null
  userId: number | null
  gdaAccess: boolean
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
